import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Text } from 'components/core/Typography';
import { Button } from 'components/core/Button';
import { Overlay } from 'components/core/GoogleMap';

function formatLowestPrice(lowestPrice) {
	if (typeof lowestPrice === 'number' && !Number.isNaN(lowestPrice)) {
		return `$${Math.floor(lowestPrice)}`;
	}
	if (
		typeof lowestPrice === 'string' &&
		lowestPrice.trim() !== '' &&
		!Number.isNaN(Number.parseFloat(lowestPrice.replaceAll(',', '')))
	) {
		return `$${Math.floor(Number.parseFloat(lowestPrice.replaceAll(',', '')))}`;
	}
	return '';
}

export function SearchPin({
	facility,
	onClick,
	onMouseEnter,
	onMouseLeave,
	selected,
	google,
	map,
}) {
	const className = classnames('search-facility-marker', { selected });
	const label = (
		<Button
			className="facility-marker-button"
			onClick={onClick}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
		>
			<Text
				className="facility-marker-label"
				size="smallMedium"
				color="blue"
				weight="extraBold"
				last
			>
				{formatLowestPrice(facility?.lowestPrice)}
			</Text>
		</Button>
	);

	return (
		<Overlay
			className={className}
			selected={selected}
			location={facility.location}
			label={label}
			google={google}
			map={map}
		/>
	);
}

SearchPin.propTypes = {
	facility: PropTypes.shape({
		lowestPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		location: PropTypes.object,
	}).isRequired,
	onClick: PropTypes.func,
	onMouseEnter: PropTypes.func,
	onMouseLeave: PropTypes.func,
	selected: PropTypes.bool,
	google: PropTypes.object,
	map: PropTypes.object,
};

export default SearchPin;
